function swapItemsInArray(items, leftIndex, rightIndex) {
    const newItems = [...items];
    const [removed] = newItems.splice(leftIndex, 1);
    newItems.splice(rightIndex, 0, removed);

    return newItems;
}

export { swapItemsInArray }